import React, { SyntheticEvent, useContext, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { NavLink, Navigate } from "react-router-dom";
import { SLinkContext } from "../state/context";
import { CallLogout } from "../api/AuthApi";
import { UserRoles, WebSocketState } from "../state/state";
import "./HeaderNavbar.css";
import { Button, Modal } from "react-bootstrap";

/** The role chip shows the user's most significant role. */
function primaryRole(userRoles: string[] | undefined): string {
  if (!userRoles) return "";
  const precedence = [UserRoles.SuperAdmin, UserRoles.Admin, UserRoles.Organiser, UserRoles.Presenter, UserRoles.Participant];
  return precedence.find((role) => userRoles.includes(role)) ?? "";
}

const HeaderNavbar = () => {
  const { state, dispatch } = useContext(SLinkContext);
  const [showLogoutPrompt, setShowLogoutPrompt] = useState(false);

  const userRoles = state.user?.userRoles.split(",");

  if (!state.user) {
    return <Navigate to="/logout" />;
  }

  const displayName = state.user.preferredName || state.user.firstname || state.user.username;
  const connected = state.connectionState === WebSocketState.Connected;

  function logoutClick(event: SyntheticEvent) {
    event.preventDefault();
    setShowLogoutPrompt(true);
  }
  function ConfirmLogout(event: SyntheticEvent) {
    event.preventDefault();
    CallLogout(dispatch);
  }
  function CancelLogout() {
    setShowLogoutPrompt(false);
  }

  return (
    <>
      <Navbar expand="md" collapseOnSelect className="sl-navbar px-3">
        <Navbar.Brand href="/">
          <img src="/imgs/ADoM-logo-216-colour.png" height="48" alt="Anglican Diocese of Melbourne" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar" label="Toggle Navigation"></Navbar.Toggle>

        <Navbar.Collapse id="navbar">
          <Nav className="me-auto">
            <NavLink to="/dashboard" end className="nav-link">
              Home
            </NavLink>
            {userRoles?.includes(UserRoles.Participant) ? (
              <NavLink to="/dashboard/meeting" className="nav-link">
                Meeting
              </NavLink>
            ) : null}
            {userRoles?.includes(UserRoles.Organiser) ? (
              <>
                <NavLink to="/dashboard/meetingadmin" className="nav-link">
                  Meeting Control
                </NavLink>
                <NavLink to="/admin/items" className="nav-link">
                  Items of Business
                </NavLink>
              </>
            ) : null}
            {userRoles?.includes(UserRoles.Admin) ? (
              <>
                <NavLink to="/admin/users" className="nav-link">
                  Users
                </NavLink>
                <NavLink to="/admin/sessions" className="nav-link">
                  Sessions
                </NavLink>
                <NavLink to="/admin/emails" className="nav-link">
                  Emails
                </NavLink>
                <NavLink to="/admin/papers" className="nav-link">
                  Synod Papers
                </NavLink>
              </>
            ) : null}
            {userRoles?.includes(UserRoles.Presenter) ? (
              <NavLink to="/admin/video-settings" className="nav-link">
                Video Settings
              </NavLink>
            ) : null}
            {userRoles?.includes(UserRoles.SuperAdmin) ? (
              <NavLink to="/admin/system" className="nav-link">
                System
              </NavLink>
            ) : null}
          </Nav>
          <Nav className="align-items-md-center gap-2">
            <span
              className={`sl-conn-pill ${connected ? "connected" : "disconnected"}`}
              title={`Realtime connection: ${state.connectionState}`}
            >
              <span className="sl-conn-dot" aria-hidden="true"></span>
              {connected ? "Live" : "Offline"}
            </span>
            <NavDropdown
              align="end"
              id="user-menu"
              title={
                <span>
                  {displayName} <span className="sl-role-chip ms-1">{primaryRole(userRoles)}</span>
                </span>
              }
            >
              <NavDropdown.Item as={NavLink} to="/dashboard/my-details">
                My Details
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={logoutClick}>Logout</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <Modal show={showLogoutPrompt} onHide={CancelLogout}>
        <Modal.Header closeButton>
          <Modal.Title>Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">Are you sure you want to logout?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" className="me-auto" onClick={CancelLogout}>
            Cancel
          </Button>
          <Button variant="primary" onClick={ConfirmLogout}>
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default HeaderNavbar;
